 /**
 * A little plugin that automatically scrolls to the first error.
 *
 * @source https://formkit.com/essentials/examples
 * - Scroll to the first validation or error on the form.
 **/

export default function scrollToErrors(node) {
	if (node.props.type === 'form') {
		const isScrollToDisabled = node.props.attrs['scroll-to-disabled'];
		const scrollToBlock = node.props.attrs['scroll-to-block'];

		function scrollTo(node) {
			const el = document.getElementById(node.props.id);

			if (el && !isScrollToDisabled) {
				// default to center to ensure that element is not hidden behind sticky header
				el.scrollIntoView({ block: scrollToBlock || 'center', behavior: 'smooth' });
			}
		}

		function scrollToErrors () {
			node.walk(child => {
				// Check if this child has errors
				if (child.ledger.value('blocking') || child.ledger.value('errors')) {
					// We found an input with validation errors
					scrollTo(child)
					// Stop searching
					return false
				}
			}, true)
		}

		const onSubmitInvalid = node.props.onSubmitInvalid
		node.props.onSubmitInvalid = () => {
			onSubmitInvalid(node)
			scrollToErrors()
		}
		node.on('unsettled:errors', scrollToErrors)
	}
	return false
}
